import { render, staticRenderFns } from "./AdministracionFacturas.vue?vue&type=template&id=2c02b8a0&scoped=true"
import script from "./AdministracionFacturas.vue?vue&type=script&lang=js"
export * from "./AdministracionFacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02b8a0",
  null
  
)

export default component.exports